module.exports = __webpack_public_path__ + "img/advantage_3.6c02d3e1.png";